import { apiFetch } from '@ami/react/core';
import { DocumentsLookupView } from './order';

const baseUrl = 'order-documents-lookup';

function search(filter, page, isPublic) {
  filter?.setPaginationParameters(page);
  const url = `${baseUrl}?${filter.toQueryString()}`;
  return apiFetch(url, 'GET', null, null, isPublic).then((documents) =>
    documents.map((x) => new DocumentsLookupView(x))
  );
}

function getDocumentDownloadUrl(filter, isPublic) {
  const url = `${baseUrl}/download?${filter.toQueryString()}`;
  return apiFetch(url, 'GET', null, null, isPublic);
}

function getLegacyDocumentDownloadUrl(filter, isPublic) {
  const url = `${baseUrl}/download-legacy?${filter.toQueryString()}`;
  return apiFetch(url, 'GET', null, null, isPublic);
}

const documentsLookupService = {
  search,
  getDocumentDownloadUrl,
  getLegacyDocumentDownloadUrl,
};
export { documentsLookupService };
